import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { GLOBAL } from "src/app/services/global";
import { wsGenerarPDFService } from "src/app/services/wsGenerarPDF.service";
import { saveAs } from "file-saver";
declare var $: any;

@Component({
  selector: "app-formulario58",
  templateUrl: "./formulario58.component.html",
  styleUrls: ["./formulario58.component.css"],
  providers: [wsGenerarPDFService],
})
export class Formulario58Component implements OnInit {
  @ViewChild("dataHtml") dataHtml: ElementRef;

  public nombreMuni = GLOBAL.nombreMuni;
  public region = GLOBAL.region;
  public color = "#ffff99";
  public data = "variable data del ts";
  pages = [1, 2, 3];
  public propiedad;
  public propietarios;
  public permiso_notariado;
  public arquitectos;
  public empresas;
  public registro_bienes;
  public tipo_condominio;
  public reglamento_copropiedad;
  public representantePropietario;
  public antecedentes;
  public cip;
  public tipo_autorizacion;
  public profesionalComp;
  public permiso_demolicion;

  constructor(
    private spinner: NgxSpinnerService,
    private _wsGenerarPDFService: wsGenerarPDFService
  ) {}

  ngOnInit() {}
  ngAfterContentChecked() {
    this.ngAfterContentInit();
  }

  ngAfterContentInit() {
    //PROPIEDAD
    if (JSON.parse(localStorage.getItem("informacionPropiedad"))) {
      if (JSON.parse(localStorage.getItem("informacionPropiedad")).length > 0) {
        this.propiedad = JSON.parse(
          localStorage.getItem("informacionPropiedad")
        );

        if (this.propiedad[0].ubicacion == "Urbano") {
          $("#urbano").attr("checked", true);
        }
        if (this.propiedad[0].ubicacion == "Rural") {
          $("#rural").attr("checked", true);
        }
      } else {
        localStorage.setItem("informacionPropiedad", JSON.stringify([]));
        this.propiedad = [
          {
            rol: "",
            id_direcc: "",
            folio: "",
            calle: "",
            calle_num: 0,
            ubicacion: "",
            direccion_completa: "",
            direc_complemento: "",
            direc_compl_num: "",
            loteo: "",
            manzana: "",
            plano: "",
            recordId: "",
          },
        ];
      }
    } else {
      localStorage.setItem("informacionPropiedad", JSON.stringify([]));
      this.propiedad = [
        {
          rol: "",
          id_direcc: "",
          folio: "",
          calle: "",
          calle_num: 0,
          ubicacion: "",
          direccion_completa: "",
          direc_complemento: "",
          direc_compl_num: "",
          loteo: "",
          manzana: "",
          plano: "",
          recordId: "",
        },
      ];
    }

    //TIPO AUTORIZACION
    if (JSON.parse(localStorage.getItem("tipo_autorizacion"))) {
      if (JSON.parse(localStorage.getItem("tipo_autorizacion")).length > 0) {
        this.tipo_autorizacion = JSON.parse(
          localStorage.getItem("tipo_autorizacion")
        );
        let Data = this.tipo_autorizacion[0].autorizacion;
        if (Data.DEMOLICION == true) {
          $("#DEMOLICION").attr("checked", true);
        }
        if (Data.OBRAPRELIMINAR == true) {
          $("#OBRAPRELIMINAR").attr("checked", true);
        }
      } else {
        localStorage.setItem("tipo_autorizacion", JSON.stringify([]));
        this.tipo_autorizacion = [{ autorizacion: "" }];
      }
    }

    //CIP
    if (JSON.parse(localStorage.getItem("cip"))) {
      if (JSON.parse(localStorage.getItem("cip")).length > 0) {
        this.cip = JSON.parse(localStorage.getItem("cip"));
      } else {
        localStorage.setItem("cip", JSON.stringify([]));
        this.cip = [{ certcip: "", fecha_cip: "" }];
      }
    }

    //REGISTRO tipo condominio
    if (JSON.parse(localStorage.getItem("tipo_condominio"))) {
      if (JSON.parse(localStorage.getItem("tipo_condominio")).length > 0) {
        this.tipo_condominio = JSON.parse(
          localStorage.getItem("tipo_condominio")
        );
        let Data = this.tipo_condominio[0].condominio;
        if (Data.A == true) {
          $("#A").attr("checked", true);
        }
        if (Data.B == true) {
          $("#B").attr("checked", true);
        }
      } else {
        localStorage.setItem("tipo_condominio", JSON.stringify([]));
        this.tipo_condominio = [{ condominio: "" }];
      }
    }

    //PROPIETARIOS
    if (JSON.parse(localStorage.getItem("propietarios"))) {
      if (JSON.parse(localStorage.getItem("propietarios")).length > 0) {
        this.propietarios = JSON.parse(localStorage.getItem("propietarios"));
      } else {
        localStorage.setItem("propietarios", JSON.stringify([]));
        this.propietarios = [
          {
            rut: "",
            nombre: "",
            apellido_mat: "",
            apellido_pat: "",
            direccion: "",
            direccion_num: "",
            direccion_complemento: "",
            direccion_completa: "",
            comuna: "",
            fono: "",
            fax: "",
            mail: "",
            recordId: "",
          },
        ];
      }
    }

    //REPRESENTANTE PROPIETARIO
    if (JSON.parse(localStorage.getItem("representantes"))) {
      if (JSON.parse(localStorage.getItem("representantes")).length > 0) {
        this.representantePropietario = JSON.parse(
          localStorage.getItem("representantes")
        ); //no es obligatorio pero si tiene informacion debe estar permiso_notariado obligatoriamente
      } else {
        localStorage.setItem("representantes", JSON.stringify([]));
        this.representantePropietario = [
          {
            rut: "",
            nombre: "",
            apellido_mat: "",
            apellido_pat: "",
            direccion: "",
            direccion_num: "",
            direccion_complemento: "",
            direccion_completa: "",
            comuna: "",
            fono: "",
            fax: "",
            mail: "",
            recordId: "",
          },
        ];
      }
    } else {
      localStorage.setItem("propietarioRepresentante", JSON.stringify([]));
      this.representantePropietario = [
        {
          rut: "",
          nombre: "",
          apellido_mat: "",
          apellido_pat: "",
          direccion: "",
          direccion_num: "",
          direccion_complemento: "",
          direccion_completa: "",
          comuna: "",
          fono: "",
          fax: "",
          mail: "",
          recordId: "",
        },
      ];
    }

    //PERMISO NOTARIADO
    if (JSON.parse(localStorage.getItem("permiso_notariado"))) {
      if (JSON.parse(localStorage.getItem("permiso_notariado")).length > 0) {
        this.permiso_notariado = JSON.parse(
          localStorage.getItem("permiso_notariado")
        );
      } else {
        localStorage.setItem("permiso_notariado", JSON.stringify([]));
        this.permiso_notariado = [
          { acreditacion: "", fecha: null, escritura: null, notario: "" },
        ];
      }
    }

    //ARQUITECTOS
    if (JSON.parse(localStorage.getItem("arquitectos"))) {
      if (JSON.parse(localStorage.getItem("arquitectos")).length > 0) {
        this.arquitectos = JSON.parse(localStorage.getItem("arquitectos"));
      } else {
        localStorage.setItem("arquitectos", JSON.stringify([]));
        this.arquitectos = [
          {
            rut: "",
            nombre: "",
            mail: "",
            apellido_mat: "",
            apellido_pat: "",
            direccion: "",
            direccion_complemento: "",
            direccion_num: "",
            comuna: "",
            fono: "",
            fax: "",
            patente: "",
            recordId: "",
          },
        ];
      }
    }

    //PROFESIONAL COMPETENTE
    if (JSON.parse(localStorage.getItem("profesionalComp"))) {
      if (JSON.parse(localStorage.getItem("profesionalComp")).length > 0) {
        this.profesionalComp = JSON.parse(
          localStorage.getItem("profesionalComp")
        );
      } else {
        localStorage.setItem("profesionalComp", JSON.stringify([]));
        this.profesionalComp = [
          {
            rut: "",
            nombre: "",
            apellido_mat: "",
            apellido_pat: "",
            direccion: "",
            direccion_num: "",
            direccion_complemento: "",
            direccion_completa: "",
            comuna: "",
            fono: "",
            mail: "",
            recordId: "",
          },
        ];
      }
    }

    //EMPRESAS
    if (JSON.parse(localStorage.getItem("empresas"))) {
      if (JSON.parse(localStorage.getItem("empresas")).length > 0) {
        this.empresas = JSON.parse(localStorage.getItem("empresas"));
      } else {
        localStorage.setItem("empresas", JSON.stringify([]));
        this.empresas = [
          {
            rut: "",
            nombre: "",
            direccion: "",
            direccion_num: "",
            direccion_complemento: "",
            direccion_completa: "",
            comuna: "",
            fono: "",
            fax: "",
            mail: "",
            recordId: "",
          },
        ];
      }
    } else {
      localStorage.setItem("empresas", JSON.stringify([]));
      this.empresas = [
        {
          rut: "",
          nombre: "",
          direccion: "",
          direccion_num: "",
          direccion_complemento: "",
          direccion_completa: "",
          comuna: "",
          fono: "",
          fax: "",
          mail: "",
          recordId: "",
        },
      ];
    }

    //REGISTRO DE BIENES
    if (JSON.parse(localStorage.getItem("registro_bienes"))) {
      if (JSON.parse(localStorage.getItem("registro_bienes")).length > 0) {
        this.registro_bienes = JSON.parse(
          localStorage.getItem("registro_bienes")
        );
      } else {
        localStorage.setItem("registro_bienes", JSON.stringify([]));
        this.registro_bienes = [
          { inscrito: "", numero: "", anio: "", bienes: "" },
        ];
      }
    }

    //REGLAMENTO COPROPIEDAD
    if (JSON.parse(localStorage.getItem("reglamento_copropiedad"))) {
      if (
        JSON.parse(localStorage.getItem("reglamento_copropiedad")).length > 0
      ) {
        this.reglamento_copropiedad = JSON.parse(
          localStorage.getItem("reglamento_copropiedad")
        );
      } else {
        localStorage.setItem("reglamento_copropiedad", JSON.stringify([]));
        this.reglamento_copropiedad = [
          {
            notaria_reg_copro: "",
            fecha_notaria: "",
            cbr_reg_copro: "",
            registro_anio: "",
            fojas_reg_copro: "",
            numero: "",
          },
        ];
      }
    }

    //PERMISO DEMOLICION
    if (JSON.parse(localStorage.getItem("permiso_demolicion"))) {
      if (JSON.parse(localStorage.getItem("permiso_demolicion")).length > 0) {
        this.permiso_demolicion = JSON.parse(
          localStorage.getItem("permiso_demolicion"));
          if (this.permiso_demolicion[0].solicitud == "SI") {
            $("#SI").attr("checked", true);
          }
          if (this.permiso_demolicion[0].solicitud == "NO") {
            $("#NO").attr("checked", true);
          }
          
      } else {
        localStorage.setItem("permiso_demolicion", JSON.stringify([]));
        this.permiso_demolicion = [
          { perm_numero: "", perm_fecha: "", solicitud: "" },
        ];
      }
    }else{
      localStorage.setItem("permiso_demolicion", JSON.stringify([]));
      this.permiso_demolicion = [
        { perm_numero: "", perm_fecha: "", solicitud: "" },
      ];
    }

    //  ANTECEDENTES QUE SE ADJUNTAN
    if (JSON.parse(localStorage.getItem("antecedentes"))) {
      if (JSON.parse(localStorage.getItem("antecedentes")).length > 0) {
        this.antecedentes = JSON.parse(localStorage.getItem("antecedentes"));

        for (let ant = 0; ant < this.antecedentes.length; ant++) {
          const filaAnt = this.antecedentes[ant];
          console.log("form56", filaAnt);

          if (filaAnt) {
            var aux = "#" + filaAnt.id;

            $(aux).attr("checked", true);
          }
        }
      } else {
        localStorage.setItem("antecedentes", JSON.stringify([]));
        this.antecedentes = [];
      }
    } else {
      localStorage.setItem("antecedentes", JSON.stringify([]));
      this.antecedentes = [];
    }
  }

  DescargarPdf() {
    this.spinner.show();
    console.log("entre");

    this._wsGenerarPDFService
      .getBase64(this.dataHtml.nativeElement.innerHTML, this.color)
      .subscribe(
        (response) => {
          console.log("response", response);

          let blob = this.convertBase64ToBlobData(response.data);
          let title = localStorage.getItem("formTitle") + ".pdf";
          saveAs(blob, title);
          this.spinner.hide();
        },
        (error) => {
          console.log("error", error);
        }
      );
  }

  convertBase64ToBlobData(
    base64Data: string,
    contentType: string = "image/png",
    sliceSize = 512
  ) {
    const byteCharacters = atob(base64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }
}
